import React, { useEffect, useState, useRef } from "react";
import {
    I2cInput,
    I2cRadio,
    I2cRadioButton,
    I2cRadioGroup,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox,
    I2cTooltip, 
    I2cPhoneField,
    I2cIcon, 
} from "@webcomponents/i2cwebcomponents/dist/react";
import { Controller } from "react-hook-form"; 
import {
    offlinePin, cardholderNotify,
    notificationChannels, customerSupportChannel, customerSupportProviders,
} from "./stringUtils";
const CardNotificationAndSupport = ({ control, handleValueChanges, methods, errors }) => {
    const cardActivation = useRef(null);
    const generalErrorMessage = "Please fill out this field.";
    
    const handleNotificationChannelsChange = (value) => {
        let updatedChannels = [
            ...(methods.getValues("pf_cardholder_notifications_channels") ?? []),
        ];
        if (updatedChannels.includes(value)) {
            // If the channel is already selected, remove it
            updatedChannels = updatedChannels.filter(
                (channel) => channel !== value,
            );
        } else {
            // If the channel is not selected, add it
            updatedChannels.push(value);
        }
        methods.setValue("pf_cardholder_notifications_channels", updatedChannels);
        methods.trigger();
        handleValueChanges();
    };

    const handleCustomerSupportChannels = (event) => {
        let selectedChannels;
        if (!event.length) selectedChannels = event.target.value;
        else selectedChannels = event;
        let updatedCardsActivationChannel = methods.watch(
            "pf_customer_support_channels",
        );
        if (updatedCardsActivationChannel.includes(selectedChannels)) {
            // If the card is already selected, remove it
            updatedCardsActivationChannel = updatedCardsActivationChannel.filter(
                (card) => card !== selectedChannels,
            );
        } else {
            // If the card is not selected, add it
            updatedCardsActivationChannel.push(selectedChannels);
        }

        methods.setValue(
            "pf_customer_support_channels",
            updatedCardsActivationChannel,
        );
        methods.trigger();
        handleValueChanges();
    };
    return (
        <React.Fragment>
            <div i2c-grid="grid gap-sm" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading mb-4">Offline PIN</div>
                    <I2cRadioGroup
                        label="Confirm if offline PIN support is required"
                        onI2cChange={(e) => {
                            methods.setValue(
                                "pf_card_offline_pin_required",
                                e.target.value,
                            );
                            methods.trigger();
                            handleValueChanges();
                        }}
                        className="mb-16"
                    >
                        {offlinePin.map((radio, index) => (
                            <I2cRadioButton
                                key={index}
                                checked={
                                    methods.watch("pf_card_offline_pin_required") ===
                                    radio.toLocaleLowerCase()
                                }
                                value={radio.toLocaleLowerCase()}
                                label={radio}
                            >
                                {radio}
                            </I2cRadioButton>
                        ))}
                    </I2cRadioGroup>
                </div>
            </div>
            <div i2c-grid="grid gap-sm" className="section-space">
                <div i2c-grid="12">
                    <span slot="label" className="organize-tooltip">
                        <div className="sub-heading">Cardholder Notifications</div>
                        <I2cTooltip
                            content="Notifications can be managed by i2c Inc. platform, based upon client notification content and scheduling parameters with notifications being send directly to Cardholders.
              Alternatively, these can be managed by the client outside of the i2c Inc. platform, data in this case can be shared through SMPP Setup/Push Alerts."
                            placement="right-start"
                        >
                            <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                        </I2cTooltip>
                    </span>
                </div>
                <div i2c-grid="12">
                    <I2cRadioGroup
                        ref={cardActivation}
                        onI2cChange={(e) => {
                            methods.setValue("pf_cardholder_notifications", e.target.value);
                            // Clear channels - use array for "send-to-holders", string for others
                            if (e.target.value === "send-to-holders") {
                                methods.setValue("pf_cardholder_notifications_channels", []);
                            } else {
                                methods.setValue("pf_cardholder_notifications_channels", "");
                            }
                            methods.trigger();
                            handleValueChanges();
                        }}
                    >
                        <div i2c-grid="grid gap-sm">
                            {cardholderNotify.map((card, index) => (
                                <div key={index} i2c-grid="6@md">
                                    <I2cListItem
                                        variant="receipt"
                                        label={card.label}
                                        sublabel=""
                                        value=""
                                        type="checkbox"
                                        checked={
                                            methods.watch("pf_cardholder_notifications") ===
                                            card.value
                                        }
                                    >
                                        <I2cRadio
                                            slot="prefix"
                                            label=""
                                            filled
                                            ignoreTab
                                            checked={
                                                methods.watch("pf_cardholder_notifications") ===
                                                card.value
                                            }
                                            value={card.value}
                                        ></I2cRadio>
                                    </I2cListItem>
                                </div>
                            ))}
                        </div>
                    </I2cRadioGroup>
                </div>

                {methods.watch("pf_cardholder_notifications") !== "" && methods.watch("pf_cardholder_notifications") !== "n/a" ? (
                    <div i2c-grid="12">
                        {methods.watch("pf_cardholder_notifications") !==
                            "send-to-holders" ? (
                            <I2cRadioGroup
                                ref={cardActivation}
                                label="Select the channel through which alerts data will be shared."
                                onI2cChange={(e) => {
                                    methods.setValue(
                                        "pf_cardholder_notifications_channels",
                                        e.target.value,
                                    );
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                            >
                                {[
                                    { label: "PUSH", value: "push" },
                                    { label: "SMPP", value: "smpp" },
                                    { label: "N/A", value: "n/a" },
                                ].map((type, index) => (
                                    <I2cRadioButton
                                        key={index}
                                        checked={
                                            methods.watch(
                                                "pf_cardholder_notifications_channels",
                                            ) === type.value
                                        }
                                        value={type.value}
                                    >
                                        {type?.label}
                                    </I2cRadioButton>
                                ))}
                            </I2cRadioGroup>
                        ) : (
                            <div className="single-field-wrapper">
                                <div className="custom-label-light mb-16">
                                    Select the channel through which alerts data will be shared.
                                </div>
                                <I2cCheckboxGroup label="" className="centeredCheckbox">
                                    <div i2c-grid="grid gap-sm">
                                        {notificationChannels.map((card, index) => (
                                            <I2cListItem
                                                key={index}
                                                i2c-grid="3@md"
                                                variant="receipt"
                                                label={card?.label}
                                                sublabel=""
                                                value=""
                                                type="checkbox"
                                                checked={
                                                    methods
                                                        .watch("pf_cardholder_notifications_channels")
                                                        ?.includes(card.value) ?? false
                                                }
                                                onI2cCheckboxClicked={(e) => {
                                                    handleNotificationChannelsChange(card.value);
                                                }}
                                            >
                                                <I2cCheckbox
                                                    slot="prefix"
                                                    filled
                                                    checked={
                                                        methods
                                                            .watch("pf_cardholder_notifications_channels")
                                                            ?.includes(card.value) ?? false
                                                    }
                                                    value={card.value}
                                                    className="customCheckbox"
                                                ></I2cCheckbox>
                                            </I2cListItem>
                                        ))}
                                    </div>
                                </I2cCheckboxGroup>
                            </div>
                        )}
                    </div>
                ) : null}
            </div>
            <div i2c-grid="grid gap-sm">
                <div i2c-grid="12">
                    <div className="sub-heading mb-4">Customer Support Channel</div>
                    <div className="custom-label-light mb-16">
                        Please confirm what customer support will be available to the
                        cardholders
                    </div>
                    <I2cCheckboxGroup ref={cardActivation} label="">
                        <div i2c-grid="grid gap-sm">
                            {customerSupportChannel.map((card, index) => (
                                <div key={index} i2c-grid="6@md">
                                    <I2cListItem
                                        variant="receipt"
                                        label={card.label}
                                        sublabel=""
                                        value=""
                                        type="checkbox"
                                        checked={
                                            methods
                                                .watch("pf_customer_support_channels")
                                                ?.includes(card.value) ?? false
                                        }
                                        onI2cCheckboxClicked={(e) => {
                                            handleCustomerSupportChannels(card.value);
                                            handleValueChanges();
                                        }}
                                    >
                                        <I2cCheckbox
                                            slot="prefix"
                                            value={card.value}
                                            label=""
                                            filled
                                            ignoreTab
                                            checked={
                                                methods
                                                    .watch("pf_customer_support_channels")
                                                    ?.includes(card.value) ?? false
                                            }

                                            className="customCheckbox"
                                        ></I2cCheckbox>
                                    </I2cListItem>
                                </div>
                            ))}
                        </div>
                    </I2cCheckboxGroup>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label-light mb-16">
                        Who will provide customer support?
                    </div>
                    <I2cRadioGroup
                        label=""
                        name="cn_card_option"
                        onI2cChange={(e) => {
                            const value = e.target.value ?? "";
                            methods.setValue("pf_customer_support_provider", value);
                            if (value !== "other") {
                                const arr = [
                                    "pf_customer_support_provider_other_company",
                                    "pf_customer_support_provider_other_contact_name",
                                    "pf_customer_support_provider_other_title",
                                    "pf_customer_support_provider_other_phone",
                                    "pf_customer_support_provider_other_phone_country",
                                    "pf_customer_support_provider_other_email",
                                ];
                                arr.forEach((field) => methods.setValue(field, ""));
                            }
                            methods.trigger();
                            handleValueChanges();
                        }}
                    >
                        <div i2c-grid="grid gap-sm">
                            {customerSupportProviders.map((option, index) => (
                                <I2cListItem
                                    key={index}
                                    i2c-grid="6@md"
                                    variant="receipt"
                                    label={option.label}
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                    sublabel=""
                                    className="option-container"
                                    checked={
                                        methods.getValues("pf_customer_support_provider") ===
                                        option.value
                                    }
                                    type="checkbox"
                                >
                                    <I2cRadio
                                        slot="prefix"
                                        filled
                                        checked={
                                            methods.getValues("pf_customer_support_provider") ===
                                            option.value
                                        }
                                        name="cardOption"
                                        value={option.value}
                                    ></I2cRadio>
                                </I2cListItem>
                            ))}
                        </div>
                    </I2cRadioGroup>
                </div>
                {methods.watch("pf_customer_support_provider") ===
                    "client-third-party" && (
                        <div i2c-grid="12">
                            <div className="custom-label-light mb-12 mt-8">
                                If using a 3rd Party Vendor, please provide details
                            </div>
                            <div i2c-grid="grid gap-column-sm gap-row-md">
                                <div i2c-grid="4@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="pf_customer_support_provider_other_company"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    name={"pf_customer_support_provider_other_company"}
                                                    className="single-input-field"
                                                    placeholder="Enter Company Name"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);
                                                        handleValueChanges();
                                                        if (value.length === 0) {
                                                            methods.setError(
                                                                "pf_customer_support_provider_other_company",
                                                                {
                                                                    message: generalErrorMessage,
                                                                },
                                                            );
                                                        } else {
                                                        }
                                                    }}
                                                    size="large"
                                                    label="Name"
                                                />
                                            )}
                                        />

                                    </div>
                                </div>
                                <div i2c-grid="4@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="pf_customer_support_provider_other_title"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    name={"pf_customer_support_provider_other_title"}
                                                    className="single-input-field"
                                                    placeholder="Enter Title"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);

                                                        methods.trigger();
                                                        handleValueChanges();
                                                        if (value.length === 0) {
                                                            methods.setError(
                                                                "pf_customer_support_provider_other_title",
                                                                {
                                                                    message: generalErrorMessage,
                                                                },
                                                            );
                                                        } else {
                                                        }
                                                    }}

                                                    size="large"
                                                    label="Title"
                                                />
                                            )}
                                        />

                                    </div>
                                </div>

                                <div i2c-grid="4@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="pf_customer_support_provider_other_email"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    name={"pf_customer_support_provider_other_email"}
                                                    className="single-input-field"
                                                    placeholder="Enter Email"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);

                                                        methods.trigger();
                                                        handleValueChanges();
                                                        if (value.length === 0) {
                                                            methods.setError(
                                                                "pf_customer_support_provider_other_email",
                                                                {
                                                                    message: generalErrorMessage,
                                                                },
                                                            );
                                                        } else {
                                                        }
                                                    }} 
                                                    type="email" 
                                                    size="large"
                                                    label="Email"
                                                />
                                            )}
                                        />

                                    </div>
                                </div>
                                <div i2c-grid="4@md">
                                    <div className="single-field-wrapper">
                                        <I2cPhoneField
                                            format="NATIONAL"
                                            label="Phone"
                                            helpIcon=""
                                            name="pf_customer_support_provider_other_phone"
                                            size="large" 
                                            country-box
                                            show-flags
                                            value={methods.watch(
                                                "pf_customer_support_provider_other_phone",
                                            )}
                                            selectedCountry={methods.watch(
                                                "pf_customer_support_provider_other_phone_country",
                                            ) || "US"}
                                            errorMessageVisible={false}
                                            onI2cChange={(e) => {
                                                const country = e.target.country;
                                                const isValid = e.target.isValid;
                                                const value = e.target.value;
                                                methods.setValue(
                                                    "pf_customer_support_provider_other_phone_country",
                                                    country,
                                                );
                                                methods.setValue(
                                                    "pf_customer_support_provider_other_phone",
                                                    value,
                                                );

                                                methods.trigger();
                                                handleValueChanges();
                                                if (!isValid) {
                                                    methods.setError(
                                                        "pf_customer_support_provider_other_phone",
                                                        {
                                                            message: e.target.guide,
                                                        },
                                                    );
                                                } else {
                                                    methods.clearErrors(
                                                        "pf_customer_support_provider_other_phone",
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div i2c-grid="4@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="pf_customer_support_provider_other_contact_name"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    name={
                                                        "pf_customer_support_provider_other_contact_name"
                                                    }
                                                    className="single-input-field"
                                                    placeholder="Enter Contact Name"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);

                                                        methods.trigger();
                                                        handleValueChanges();
                                                        if (value.length === 0) {
                                                            methods.setError(
                                                                "pf_customer_support_provider_other_contact_name",
                                                                {
                                                                    message: generalErrorMessage,
                                                                },
                                                            );
                                                        } else {
                                                        }
                                                    }}

                                                    size="large"
                                                    label="Company Name"
                                                />
                                            )}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        </React.Fragment>
    );
};

export default CardNotificationAndSupport;
